
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const BlogPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const blogPosts = [
    {
      id: 1,
      title: "Cómo Diagnosticar Problemas en Módulos ECU: Guía Completa 2024",
      excerpt: "Aprende las técnicas más efectivas para identificar y solucionar fallas en módulos ECU utilizando equipos de diagnóstico profesional.",
      content: `
        <h2>Introducción al Diagnóstico de Módulos ECU</h2>
        <p>El diagnóstico de módulos ECU (Electronic Control Unit) es una de las habilidades más importantes en la electrónica automotriz moderna. Estos módulos controlan prácticamente todos los sistemas del vehículo, desde el motor hasta los sistemas de seguridad.</p>
        
        <h3>¿Qué es un Módulo ECU?</h3>
        <p>Un módulo ECU es el cerebro electrónico de tu vehículo. Controla y monitorea diversos sistemas como:</p>
        <ul>
          <li>Sistema de inyección de combustible</li>
          <li>Control de emisiones</li>
          <li>Sistema de encendido</li>
          <li>Transmisión automática</li>
          <li>Sistemas de seguridad (ABS, ESP)</li>
        </ul>

        <h3>Síntomas Comunes de Fallas en ECU</h3>
        <p>Algunos síntomas que pueden indicar problemas en el módulo ECU incluyen:</p>
        <ul>
          <li>Luz de check engine encendida</li>
          <li>Problemas de arranque</li>
          <li>Consumo excesivo de combustible</li>
          <li>Pérdida de potencia</li>
          <li>Funcionamiento irregular del motor</li>
        </ul>

        <h3>Proceso de Diagnóstico</h3>
        <p><strong>1. Conexión del Scanner:</strong> Utiliza un scanner profesional para conectarte al puerto OBD-II del vehículo.</p>
        <p><strong>2. Lectura de Códigos:</strong> Lee los códigos de error almacenados en el módulo ECU.</p>
        <p><strong>3. Análisis de Datos en Vivo:</strong> Monitorea los parámetros del motor en tiempo real.</p>
        <p><strong>4. Pruebas de Componentes:</strong> Verifica el funcionamiento de sensores y actuadores.</p>

        <h3>Herramientas Necesarias</h3>
        <ul>
          <li>Scanner automotriz profesional</li>
          <li>Multímetro digital</li>
          <li>Osciloscopio (para diagnósticos avanzados)</li>
          <li>Manuales de servicio del fabricante</li>
        </ul>

        <h3>Consejos para un Diagnóstico Efectivo</h3>
        <p>Para obtener los mejores resultados en el diagnóstico de módulos ECU:</p>
        <ul>
          <li>Siempre verifica las conexiones eléctricas antes de culpar al módulo</li>
          <li>Utiliza diagramas eléctricos actualizados</li>
          <li>Documenta todos los códigos de error encontrados</li>
          <li>Realiza pruebas de continuidad en los circuitos</li>
          <li>Mantén actualizado el software de tu scanner</li>
        </ul>

        <h3>Conclusión</h3>
        <p>El diagnóstico de módulos ECU requiere conocimiento técnico, herramientas adecuadas y experiencia. En Mechatronicx contamos con el equipo y la experiencia necesaria para diagnosticar y reparar cualquier problema en los módulos electrónicos de tu vehículo.</p>
      `,
      category: "Diagnóstico",
      author: "Carlos Rodríguez",
      date: "2024-12-15",
      readTime: "8 min",
      image: "https://public.readdy.ai/ai/img_res/2ed352ee5616a7d1dd52509c7a8c1eaf.jpg",
      tags: ["ECU", "Diagnóstico", "Automotriz"]
    },
    {
      id: 2,
      title: "Programación de Llaves Inteligentes: Tendencias y Nuevas Tecnologías",
      excerpt: "Descubre las últimas innovaciones en programación de llaves inteligentes y cómo mantenerte actualizado en esta área en constante evolución.",
      content: `
        <h2>La Evolución de las Llaves Automotrices</h2>
        <p>La programación de llaves inteligentes ha evolucionado significativamente en los últimos años. Desde las llaves mecánicas tradicionales hasta los sistemas keyless actuales, la tecnología ha transformado completamente la seguridad vehicular.</p>

        <h3>Tipos de Llaves Modernas</h3>
        <p><strong>Llaves con Transponder:</strong> Contienen un chip que se comunica con el módulo de control del vehículo.</p>
        <p><strong>Llaves Inteligentes (Smart Keys):</strong> Permiten arrancar el vehículo sin insertar la llave en el switch.</p>
        <p><strong>Llaves de Proximidad:</strong> El vehículo detecta la presencia de la llave y permite el acceso automático.</p>

        <h3>Proceso de Programación</h3>
        <p>La programación de llaves inteligentes involucra varios pasos críticos:</p>
        <ol>
          <li><strong>Identificación del Vehículo:</strong> Determinar el año, marca, modelo y sistema de seguridad</li>
          <li><strong>Lectura de Códigos:</strong> Extraer los códigos de seguridad del vehículo</li>
          <li><strong>Programación del Transponder:</strong> Configurar el chip de la llave</li>
          <li><strong>Sincronización:</strong> Establecer comunicación entre la llave y el vehículo</li>
          <li><strong>Pruebas:</strong> Verificar el funcionamiento correcto</li>
        </ol>

        <h3>Tecnologías Emergentes</h3>
        <p><strong>Llaves Digitales:</strong> Aplicaciones móviles que funcionan como llaves del vehículo.</p>
        <p><strong>Biometría:</strong> Sistemas que utilizan huellas dactilares o reconocimiento facial.</p>
        <p><strong>Blockchain:</strong> Tecnología para mejorar la seguridad en la comunicación entre dispositivos.</p>

        <h3>Desafíos en la Programación</h3>
        <ul>
          <li>Sistemas de seguridad cada vez más complejos</li>
          <li>Necesidad de equipos especializados actualizados</li>
          <li>Capacitación constante del personal técnico</li>
          <li>Acceso a códigos de seguridad del fabricante</li>
        </ul>

        <h3>Marcas que Atendemos</h3>
        <p>En Mechatronicx programamos llaves para todas las marcas principales:</p>
        <ul>
          <li>Toyota, Honda, Nissan</li>
          <li>Chevrolet, Ford, Volkswagen</li>
          <li>Hyundai, Kia, Mazda</li>
          <li>Renault, Peugeot, Citroën</li>
          <li>Y muchas más marcas</li>
        </ul>

        <h3>Consejos para Propietarios</h3>
        <ul>
          <li>Siempre ten una llave de respaldo programada</li>
          <li>Reemplaza las baterías de las llaves inteligentes regularmente</li>
          <li>Evita exponer las llaves a temperaturas extremas</li>
          <li>Acude a profesionales certificados para la programación</li>
        </ul>

        <h3>El Futuro de las Llaves Automotrices</h3>
        <p>El futuro apunta hacia sistemas completamente digitales, donde el smartphone será la llave principal del vehículo. Sin embargo, siempre existirá la necesidad de sistemas de respaldo físicos para garantizar el acceso en caso de fallas tecnológicas.</p>
      `,
      category: "Programación",
      author: "María González",
      date: "2024-12-12",
      readTime: "6 min",
      image: "https://readdy.ai/api/search-image?query=Smart%20car%20key%20programming%20equipment%2C%20automotive%20key%20programmer%20device%2C%20electronic%20car%20keys%20and%20programming%20tools%2C%20modern%20automotive%20locksmith%20technology&width=600&height=400&seq=blog2&orientation=landscape",
      tags: ["Llaves", "Programación", "Tecnología"]
    },
    {
      id: 3,
      title: "5 Errores Comunes al Reparar Módulos BCM y Cómo Evitarlos",
      excerpt: "Conoce los errores más frecuentes en la reparación de módulos BCM y las mejores prácticas para garantizar reparaciones exitosas.",
      content: `
        <h2>¿Qué es un Módulo BCM?</h2>
        <p>Los módulos BCM (Body Control Module) son componentes críticos en los vehículos modernos que controlan múltiples funciones del cuerpo del vehículo, incluyendo luces, ventanas, cerraduras, y sistemas de confort.</p>

        <h3>Error #1: No Realizar un Diagnóstico Completo</h3>
        <p><strong>El Problema:</strong> Muchos técnicos asumen que el BCM está defectuoso sin realizar un diagnóstico exhaustivo.</p>
        <p><strong>La Solución:</strong> Siempre verifica:</p>
        <ul>
          <li>Voltaje de alimentación</li>
          <li>Conexiones a tierra</li>
          <li>Integridad de los arneses</li>
          <li>Códigos de error relacionados</li>
        </ul>

        <h3>Error #2: No Respaldar la Información Original</h3>
        <p><strong>El Problema:</strong> Perder la configuración original del módulo durante la reparación.</p>
        <p><strong>La Solución:</strong> Antes de cualquier intervención:</p>
        <ul>
          <li>Lee y guarda todos los códigos de configuración</li>
          <li>Documenta los parámetros de calibración</li>
          <li>Realiza una copia de seguridad de la EEPROM</li>
        </ul>

        <h3>Error #3: Usar Herramientas Inadecuadas</h3>
        <p><strong>El Problema:</strong> Utilizar equipos genéricos o desactualizados para la programación.</p>
        <p><strong>La Solución:</strong> Invierte en:</p>
        <ul>
          <li>Programadores específicos para cada marca</li>
          <li>Software actualizado regularmente</li>
          <li>Adaptadores y cables originales</li>
        </ul>

        <h3>Error #4: Ignorar las Actualizaciones de Software</h3>
        <p><strong>El Problema:</strong> No actualizar el firmware del BCM después de la reparación.</p>
        <p><strong>La Solución:</strong></p>
        <ul>
          <li>Verifica siempre la versión de software más reciente</li>
          <li>Aplica las actualizaciones recomendadas por el fabricante</li>
          <li>Documenta las versiones instaladas</li>
        </ul>

        <h3>Error #5: No Realizar Pruebas Funcionales Completas</h3>
        <p><strong>El Problema:</strong> Entregar el vehículo sin verificar todas las funciones controladas por el BCM.</p>
        <p><strong>La Solución:</strong> Prueba sistemáticamente:</p>
        <ul>
          <li>Todas las luces (interiores y exteriores)</li>
          <li>Sistemas de ventanas y espejos</li>
          <li>Cerraduras centralizadas</li>
          <li>Sistemas de alarma</li>
          <li>Funciones de confort</li>
        </ul>

        <h3>Mejores Prácticas para Reparación de BCM</h3>
        <p><strong>Preparación:</strong></p>
        <ul>
          <li>Asegúrate de tener una batería completamente cargada</li>
          <li>Utiliza un cargador/mantenedor de batería durante el proceso</li>
          <li>Trabaja en un ambiente libre de interferencias electromagnéticas</li>
        </ul>

        <p><strong>Durante la Reparación:</strong></p>
        <ul>
          <li>Sigue estrictamente los procedimientos del fabricante</li>
          <li>No interrumpas el proceso de programación</li>
          <li>Mantén registros detallados de cada paso</li>
        </ul>

        <p><strong>Después de la Reparación:</strong></p>
        <ul>
          <li>Realiza un borrado de códigos de error</li>
          <li>Ejecuta todas las calibraciones necesarias</li>
          <li>Prueba el vehículo en condiciones reales</li>
        </ul>

        <h3>Conclusión</h3>
        <p>La reparación exitosa de módulos BCM requiere conocimiento técnico, herramientas adecuadas y atención al detalle. Evitar estos errores comunes te ayudará a lograr reparaciones más exitosas y clientes más satisfechos.</p>
      `,
      category: "Tutoriales",
      author: "Luis Martínez",
      date: "2024-12-10",
      readTime: "10 min",
      image: "https://readdy.ai/api/search-image?query=BCM%20body%20control%20module%20repair%2C%20automotive%20electronic%20module%20on%20workbench%2C%20technician%20repairing%20car%20computer%20module%2C%20professional%20automotive%20electronics%20repair&width=600&height=400&seq=blog3&orientation=landscape",
      tags: ["BCM", "Reparación", "Tutoriales"]
    },
    {
      id: 4,
      title: "Chevrolet Captiva: Solución a Problemas Eléctricos y Fallas de ECU",
      excerpt: "Guía completa para diagnosticar y reparar los problemas eléctricos más comunes en Chevrolet Captiva, incluyendo fallas de ECU y módulos electrónicos.",
      content: `
        <h2>Problemas Eléctricos Comunes en Chevrolet Captiva</h2>
        <p>El Chevrolet Captiva es un SUV popular que puede presentar diversos problemas eléctricos y de ECU. En Mechatronicx hemos desarrollado protocolos específicos para diagnosticar y reparar estas fallas de manera eficiente.</p>

        <h3>Síntomas Más Frecuentes</h3>
        <p>Los propietarios de Chevrolet Captiva suelen reportar los siguientes problemas:</p>
        <ul>
          <li>Luz de check engine intermitente o permanente</li>
          <li>Problemas de arranque en frío</li>
          <li>Pérdida de potencia durante la aceleración</li>
          <li>Funcionamiento irregular del motor</li>
          <li>Fallas en el sistema de transmisión automática</li>
          <li>Problemas con el sistema de aire acondicionado</li>
        </ul>

        <h3>Fallas de ECU Específicas</h3>
        <p><strong>Módulo de Control del Motor (ECM):</strong> Problemas con la gestión de combustible y encendido.</p>
        <p><strong>Módulo de Control de Transmisión (TCM):</strong> Fallas en los cambios automáticos y modo deportivo.</p>
        <p><strong>Módulo de Control del Cuerpo (BCM):</strong> Problemas con luces, ventanas eléctricas y sistemas de confort.</p>

        <h3>Proceso de Diagnóstico Especializado</h3>
        <p><strong>1. Conexión de Scanner Profesional:</strong> Utilizamos equipos específicos para GM/Chevrolet.</p>
        <p><strong>2. Lectura de Códigos DTC:</strong> Identificamos códigos de error específicos del Captiva.</p>
        <p><strong>3. Análisis de Parámetros en Vivo:</strong> Monitoreamos sensores y actuadores en tiempo real.</p>
        <p><strong>4. Pruebas de Actuadores:</strong> Verificamos el funcionamiento de componentes eléctricos.</p>
        <p><strong>5. Inspección Visual:</strong> Revisamos arneses y conectores por corrosión o daños.</p>

        <h3>Reparaciones Más Comunes</h3>
        <ul>
          <li>Reprogramación de módulos ECU</li>
          <li>Reparación de arneses eléctricos dañados</li>
          <li>Reemplazo de sensores defectuosos</li>
          <li>Actualización de software de módulos</li>
          <li>Reparación de conectores corroídos</li>
        </ul>

        <h3>Herramientas Especializadas</h3>
        <p>Para trabajar en Chevrolet Captiva utilizamos:</p>
        <ul>
          <li>Scanner GM Tech2 y MDI</li>
          <li>Software GM SPS (Service Programming System)</li>
          <li>Multímetro automotriz de precisión</li>
          <li>Osciloscopio para análisis de señales</li>
          <li>Diagramas eléctricos actualizados</li>
        </ul>

        <h3>Prevención y Mantenimiento</h3>
        <p>Para evitar problemas eléctricos en tu Captiva:</p>
        <ul>
          <li>Realiza mantenimiento preventivo cada 10,000 km</li>
          <li>Revisa regularmente el estado de la batería</li>
          <li>Mantén limpios los terminales de batería</li>
          <li>Evita modificaciones eléctricas no autorizadas</li>
          <li>Atiende inmediatamente cualquier luz de advertencia</li>
        </ul>

        <h3>Garantía y Seguimiento</h3>
        <p>En Mechatronicx ofrecemos garantía completa en todas las reparaciones de Chevrolet Captiva. Nuestro equipo especializado cuenta con la experiencia y herramientas necesarias para resolver cualquier problema eléctrico o de ECU en tu vehículo.</p>
      `,
      category: "Casos Específicos",
      author: "Carlos Rodríguez",
      date: "2024-12-08",
      readTime: "12 min",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/865312a33e31c02c1c7f36ea41954f58.webp",
      tags: ["Chevrolet", "Captiva", "ECU", "Eléctrico"]
    },
    {
      id: 5,
      title: "Ford Fiesta: Diagnóstico y Reparación de Problemas Eléctricos y ECU",
      excerpt: "Soluciones especializadas para los problemas eléctricos más comunes en Ford Fiesta, incluyendo fallas de ECU y sistemas electrónicos avanzados.",
      content: `
        <h2>Problemas Eléctricos en Ford Fiesta</h2>
        <p>El Ford Fiesta es uno de los vehículos más populares en Colombia, pero puede presentar problemas eléctricos específicos que requieren atención especializada. En Mechatronicx tenemos amplia experiencia reparando estos sistemas.</p>

        <h3>Fallas Más Comunes</h3>
        <p>Los Ford Fiesta suelen presentar los siguientes problemas eléctricos:</p>
        <ul>
          <li>Problemas con el módulo de control del motor (PCM)</li>
          <li>Fallas en el sistema de encendido</li>
          <li>Problemas con sensores de oxígeno</li>
          <li>Fallas en el sistema de inyección</li>
          <li>Problemas con el módulo ABS</li>
          <li>Fallas en el sistema de aire acondicionado</li>
        </ul>

        <h3>Síntomas de Alerta</h3>
        <p>Identifica estos síntomas en tu Ford Fiesta:</p>
        <ul>
          <li>Motor que se apaga inesperadamente</li>
          <li>Ralentí irregular o inestable</li>
          <li>Pérdida de potencia en aceleración</li>
          <li>Consumo excesivo de combustible</li>
          <li>Luces de advertencia en el tablero</li>
          <li>Problemas para arrancar en frío</li>
        </ul>

        <h3>Diagnóstico Especializado Ford</h3>
        <p><strong>1. Scanner Ford IDS:</strong> Utilizamos equipos específicos de Ford para diagnóstico preciso.</p>
        <p><strong>2. Análisis de Módulos:</strong> Revisamos PCM, ABS, BCM y otros módulos críticos.</p>
        <p><strong>3. Pruebas de Componentes:</strong> Verificamos sensores, actuadores y circuitos.</p>
        <p><strong>4. Análisis de Datos:</strong> Interpretamos parámetros específicos del Fiesta.</p>

        <h3>Reparaciones Especializadas</h3>
        <p>Nuestros servicios incluyen:</p>
        <ul>
          <li>Reprogramación de módulos PCM</li>
          <li>Reparación de circuitos de inyección</li>
          <li>Reemplazo de sensores específicos Ford</li>
          <li>Actualización de software de módulos</li>
          <li>Reparación de arneses eléctricos</li>
          <li>Calibración de sistemas electrónicos</li>
        </ul>

        <h3>Tecnología Ford Específica</h3>
        <p>El Ford Fiesta utiliza tecnologías específicas que requieren conocimiento especializado:</p>
        <ul>
          <li>Sistema EcoBoost (en versiones turbo)</li>
          <li>Módulo de control integrado</li>
          <li>Sistema de gestión térmica</li>
          <li>Red CAN Bus avanzada</li>
          <li>Sistemas de seguridad integrados</li>
        </ul>

        <h3>Herramientas Ford Certificadas</h3>
        <p>Utilizamos equipos certificados por Ford:</p>
        <ul>
          <li>Ford IDS (Integrated Diagnostic Software)</li>
          <li>Scanner VCM II</li>
          <li>Software Ford FDRS</li>
          <li>Diagramas eléctricos Ford originales</li>
          <li>Herramientas de calibración específicas</li>
        </ul>

        <h3>Mantenimiento Preventivo</h3>
        <p>Para mantener tu Ford Fiesta en óptimas condiciones:</p>
        <ul>
          <li>Revisa el sistema eléctrico cada 15,000 km</li>
          <li>Mantén actualizado el software de módulos</li>
          <li>Utiliza combustible de calidad</li>
          <li>Revisa regularmente el filtro de aire</li>
          <li>Atiende inmediatamente las luces de advertencia</li>
        </ul>

        <h3>Experiencia Comprobada</h3>
        <p>En Mechatronicx hemos reparado cientos de Ford Fiesta con problemas eléctricos. Nuestro equipo conoce a fondo estos vehículos y puede diagnosticar y reparar cualquier falla eléctrica o de ECU de manera eficiente y confiable.</p>
      `,
      category: "Casos Específicos",
      author: "María González",
      date: "2024-12-05",
      readTime: "11 min",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/4069eeb6448d31045d58f2fc5564d2d1.jpeg",
      tags: ["Ford", "Fiesta", "ECU", "Diagnóstico"]
    },
    {
      id: 6,
      title: "Ford Lobo F-150: Soluciones Avanzadas para Problemas Eléctricos",
      excerpt: "Diagnóstico y reparación especializada de sistemas eléctricos en Ford Lobo F-150, incluyendo módulos de control y sistemas de alta tecnología.",
      content: `
        <h2>Ford Lobo F-150: Complejidad Eléctrica Avanzada</h2>
        <p>El Ford Lobo F-150 es una pickup de alta gama con sistemas eléctricos complejos que requieren conocimiento especializado. En Mechatronicx tenemos la experiencia y herramientas necesarias para atender estos vehículos premium.</p>

        <h3>Sistemas Eléctricos Avanzados</h3>
        <p>El Ford Lobo F-150 incorpora tecnologías de vanguardia:</p>
        <ul>
          <li>Sistema de gestión de batería inteligente</li>
          <li>Módulos de control múltiples interconectados</li>
          <li>Sistema de tracción inteligente 4WD</li>
          <li>Control electrónico de suspensión</li>
          <li>Sistema de remolque inteligente</li>
          <li>Pantallas táctiles y sistemas de infoentretenimiento</li>
        </ul>

        <h3>Problemas Eléctricos Comunes</h3>
        <p>Los Ford Lobo F-150 pueden presentar:</p>
        <ul>
          <li>Fallas en el módulo de control del motor (PCM)</li>
          <li>Problemas con el sistema de tracción 4WD</li>
          <li>Fallas en sensores de posición y velocidad</li>
          <li>Problemas con el sistema de carga</li>
          <li>Fallas en módulos de confort y conveniencia</li>
          <li>Problemas con sistemas de asistencia al conductor</li>
        </ul>

        <h3>Diagnóstico de Alta Tecnología</h3>
        <p><strong>1. Scanner Ford Professional:</strong> Utilizamos equipos de diagnóstico de última generación.</p>
        <p><strong>2. Análisis de Red CAN:</strong> Verificamos la comunicación entre módulos.</p>
        <p><strong>3. Pruebas de Sistemas Integrados:</strong> Evaluamos el funcionamiento conjunto de sistemas.</p>
        <p><strong>4. Análisis de Parámetros Avanzados:</strong> Monitoreamos datos específicos del F-150.</p>

        <h3>Reparaciones Especializadas</h3>
        <p>Nuestros servicios para Ford Lobo F-150 incluyen:</p>
        <ul>
          <li>Reprogramación de módulos de control avanzados</li>
          <li>Reparación de sistemas de tracción 4WD</li>
          <li>Calibración de sensores de suspensión</li>
          <li>Actualización de software de sistemas</li>
          <li>Reparación de arneses de alta corriente</li>
          <li>Diagnóstico de sistemas híbridos (versiones híbridas)</li>
        </ul>

        <h3>Tecnología Ford F-150 Específica</h3>
        <p>Trabajamos con tecnologías exclusivas del F-150:</p>
        <ul>
          <li>Sistema EcoBoost con turbocompresor</li>
          <li>Gestión térmica avanzada</li>
          <li>Sistema de parada/arranque automático</li>
          <li>Control de tracción selectivo</li>
          <li>Sistema de gestión de remolque</li>
          <li>Módulos de seguridad avanzados</li>
        </ul>

        <h3>Equipos Especializados</h3>
        <p>Para atender Ford Lobo F-150 utilizamos:</p>
        <ul>
          <li>Ford IDS con licencias F-150</li>
          <li>Scanner VCM III de última generación</li>
          <li>Osciloscopio de alta resolución</li>
          <li>Analizador de red CAN Bus</li>
          <li>Herramientas de calibración específicas</li>
          <li>Software Ford FDRS actualizado</li>
        </ul>

        <h3>Mantenimiento Preventivo Premium</h3>
        <p>Para mantener tu Ford Lobo F-150 en condiciones óptimas:</p>
        <ul>
          <li>Diagnóstico completo cada 20,000 km</li>
          <li>Actualización regular de software</li>
          <li>Revisión de sistemas de alta corriente</li>
          <li>Mantenimiento de batería de alta capacidad</li>
          <li>Calibración periódica de sensores</li>
          <li>Verificación de sistemas de asistencia</li>
        </ul>

        <h3>Garantía y Confiabilidad</h3>
        <p>En Mechatronicx entendemos la importancia de tu Ford Lobo F-150. Ofrecemos servicios especializados con garantía completa, utilizando únicamente herramientas y procedimientos certificados por Ford para garantizar el máximo rendimiento y confiabilidad.</p>
      `,
      category: "Casos Específicos",
      author: "Luis Martínez",
      date: "2024-12-03",
      readTime: "14 min",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/13ff77aa5d32ee1e12f1314eddf38352.jpeg",
      tags: ["Ford", "Lobo", "F-150", "Avanzado"]
    },
    {
      id: 7,
      title: "Renault Koleos 2.5 2010: Diagnóstico y Solución de Problemas Eléctricos",
      excerpt: "Guía especializada para diagnosticar y reparar los problemas eléctricos más comunes en Renault Koleos 2.5 2010, incluyendo fallas de ECU y sistemas electrónicos.",
      content: `
        <h2>Renault Koleos 2.5 2010: Análisis Técnico Especializado</h2>
        <p>El Renault Koleos 2.5 del año 2010 es un SUV robusto que puede presentar problemas eléctricos específicos relacionados con su sistema de gestión electrónica. En Mechatronicx hemos desarrollado protocolos especializados para diagnosticar y reparar estas fallas de manera efectiva.</p>

        <h3>Características del Sistema Eléctrico</h3>
        <p>El Koleos 2.5 2010 incorpora tecnología Renault-Nissan con las siguientes características:</p>
        <ul>
          <li>Motor QR25DE de 2.5L con inyección multipunto</li>
          <li>Sistema de gestión electrónica Hitachi</li>
          <li>Transmisión CVT con control electrónico</li>
          <li>Sistema de tracción integral AWD electrónico</li>
          <li>Red CAN Bus para comunicación entre módulos</li>
          <li>Sistema de inmobilizador NATS (Nissan Anti-Theft System)</li>
        </ul>

        <h3>Problemas Eléctricos Más Frecuentes</h3>
        <p>Los propietarios de Koleos 2.5 2010 reportan comúnmente:</p>
        <ul>
          <li>Luz de check engine intermitente</li>
          <li>Problemas de arranque en frío</li>
          <li>Fallas en el sistema CVT (códigos P0746, P0776)</li>
          <li>Problemas con sensores de oxígeno</li>
          <li>Fallas en el sistema de tracción AWD</li>
          <li>Problemas con el módulo BCM (luces y accesorios)</li>
          <li>Fallas en el sistema de aire acondicionado</li>
        </ul>

        <h3>Códigos de Error Específicos</h3>
        <p><strong>Códigos del Motor (ECM):</strong></p>
        <ul>
          <li>P0171/P0174: Mezcla pobre en bancos 1 y 2</li>
          <li>P0420: Eficiencia del catalizador</li>
          <li>P0507: RPM de ralentí altas</li>
          <li>P0011/P0021: Posición del árbol de levas</li>
        </ul>

        <p><strong>Códigos de Transmisión CVT:</strong></p>
        <ul>
          <li>P0746: Solenoide de control de presión</li>
          <li>P0776: Solenoide B de control de presión</li>
          <li>P1778: Sensor de velocidad de entrada CVT</li>
        </ul>

        <h3>Proceso de Diagnóstico Especializado</h3>
        <p><strong>1. Conexión Scanner Renault/Nissan:</strong> Utilizamos equipos específicos para la alianza Renault-Nissan.</p>
        <p><strong>2. Lectura de Módulos:</strong> Escaneamos ECM, TCM, BCM, ABS y otros módulos críticos.</p>
        <p><strong>3. Análisis de Datos en Vivo:</strong> Monitoreamos parámetros específicos del QR25DE.</p>
        <p><strong>4. Pruebas de Actuadores:</strong> Verificamos solenoides CVT y actuadores del motor.</p>
        <p><strong>5. Inspección de Arneses:</strong> Revisamos conectores específicos propensos a corrosión.</p>

        <h3>Reparaciones Especializadas</h3>
        <p>Nuestros servicios para Koleos 2.5 2010 incluyen:</p>
        <ul>
          <li>Reprogramación de ECM con software actualizado</li>
          <li>Reparación de solenoides CVT</li>
          <li>Reemplazo de sensores de oxígeno específicos</li>
          <li>Reparación del sistema de tracción AWD</li>
          <li>Actualización de software de módulos</li>
          <li>Reparación de arneses del motor</li>
          <li>Calibración del sistema de inmobilizador</li>
        </ul>

        <h3>Herramientas Especializadas Renault</h3>
        <p>Para trabajar en Koleos 2.5 utilizamos:</p>
        <ul>
          <li>Scanner Renault CAN Clip</li>
          <li>Consult III Plus (para sistemas Nissan)</li>
          <li>Software Renault CLIP actualizado</li>
          <li>Multímetro automotriz de precisión</li>
          <li>Osciloscopio para análisis de señales CVT</li>
          <li>Diagramas eléctricos Renault originales</li>
        </ul>

        <h3>Mantenimiento Preventivo</h3>
        <p>Para evitar problemas eléctricos en tu Koleos 2.5:</p>
        <ul>
          <li>Cambio de aceite CVT cada 60,000 km</li>
          <li>Limpieza del cuerpo de aceleración cada 30,000 km</li>
          <li>Revisión de conectores cada 20,000 km</li>
          <li>Actualización de software de módulos anualmente</li>
          <li>Verificación del sistema de enfriamiento</li>
          <li>Mantenimiento del filtro de aire regularmente</li>
        </ul>

        <h3>Puntos Críticos de Inspección</h3>
        <p>En el Koleos 2.5 2010, prestamos especial atención a:</p>
        <ul>
          <li>Conectores del arnés del motor (propensos a corrosión)</li>
          <li>Sensores de posición del árbol de levas</li>
          <li>Solenoides de la transmisión CVT</li>
          <li>Módulo de control del AWD</li>
          <li>Sistema de ventilación del cárter</li>
          <li>Sensores de oxígeno (vida útil limitada)</li>
        </ul>

        <h3>Garantía y Experiencia</h3>
        <p>En Mechatronicx contamos con amplia experiencia en vehículos Renault-Nissan. Ofrecemos garantía completa en todas las reparaciones del Koleos 2.5 2010, utilizando herramientas originales y procedimientos certificados por el fabricante.</p>
      `,
      category: "Casos Específicos",
      author: "Carlos Rodríguez",
      date: "2024-12-18",
      readTime: "13 min",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/41a46ff29fd80eb06e8ce010fb26d89b.jpeg",
      tags: ["Renault", "Koleos", "2010", "CVT", "ECU"]
    }
  ];

  const [selectedPost, setSelectedPost] = useState(null);

  useEffect(() => {
    if (!selectedPost) {
      // Add structured data for blog page
      const structuredData = {
        "@context": "https://schema.org",
        "@type": "Blog",
        "name": "Blog Técnico Automotriz - Mechatronicx SAS",
        "description": "Contenido técnico especializado para profesionales automotrices",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/blog`,
        "publisher": {
          "@type": "Organization",
          "name": "Mechatronicx SAS",
          "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
        },
        "blogPost": blogPosts.slice(0, 5).map(post => ({
          "@type": "BlogPosting",
          "headline": post.title,
          "description": post.excerpt,
          "author": {
            "@type": "Person",
            "name": post.author
          },
          "datePublished": post.date,
          "image": post.image,
          "keywords": post.tags.join(', ')
        }))
      };

      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(structuredData);
      document.head.appendChild(script);

      return () => {
        if (document.head.contains(script)) {
          document.head.removeChild(script);
        }
      };
    } else {
      // Add structured data for individual article
      const articleData = {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": selectedPost.title,
        "description": selectedPost.excerpt,
        "author": {
          "@type": "Person",
          "name": selectedPost.author
        },
        "datePublished": selectedPost.date,
        "image": selectedPost.image,
        "publisher": {
          "@type": "Organization",
          "name": "Mechatronicx SAS",
          "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
        },
        "keywords": selectedPost.tags.join(', '),
        "articleSection": selectedPost.category
      };

      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(articleData);
      document.head.appendChild(script);

      return () => {
        if (document.head.contains(script)) {
          document.head.removeChild(script);
        }
      };
    }
  }, [selectedPost]);

  const filteredPosts = blogPosts.filter(post => {
    const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         post.excerpt.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         post.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    return matchesSearch;
  });

  const featuredPost = blogPosts[0];

  const handleWhatsAppContact = () => {
    window.open('https://wa.me/573202047129', '_blank');
  };

  const handlePhoneCall = () => {
    window.open('tel:+573202047129', '_self');
  };

  if (selectedPost) {
    return (
      <div className="min-h-screen bg-white">
        {/* Header */}
        <header className="bg-white shadow-lg fixed w-full top-0 z-50">
          <div className="container mx-auto px-4 py-3 md:py-4">
            <div className="flex items-center justify-between">
              <Link to="/" className="flex items-center space-x-2 md:space-x-3 cursor-pointer">
                <img 
                  src="https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/db14669796bfd9c6751821edba8bd22a.png" 
                  alt="Mechatronicx Logo" 
                  className="h-8 md:h-12 w-auto"
                />
                <div>
                  <h1 className="text-sm md:text-xl font-bold text-gray-900">MECHATRONICX</h1>
                  <p className="text-xs text-gray-600 hidden md:block">Soluciones Electrónicas Automotrices</p>
                </div>
              </Link>

              {/* Desktop Navigation */}
              <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8">
                <Link to="/" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Inicio</Link>
                <Link to="/servicios" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Servicios</Link>
                <Link to="/productos" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Productos</Link>
                <Link to="/empresas" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Empresas</Link>
                <Link to="/blog" className="text-red-600 font-semibold cursor-pointer">Blog</Link>
                <button 
                  onClick={handleWhatsAppContact}
                  className="bg-red-600 text-white px-4 xl:px-6 py-2 rounded-full hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer text-sm xl:text-base"
                >
                  Cotizar Ahora
                </button>
              </nav>

              {/* Mobile Menu Button */}
              <button 
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="lg:hidden text-gray-700 cursor-pointer p-2"
              >
                <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
              </button>
            </div>

            {/* Mobile Navigation */}
            {isMobileMenuOpen && (
              <div className="lg:hidden mt-4 pb-4 border-t border-gray-200">
                <nav className="flex flex-col space-y-3 pt-4">
                  <Link 
                    to="/" 
                    className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer py-2 px-4 rounded-lg"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Inicio
                  </Link>
                  <Link 
                    to="/servicios" 
                    className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer py-2 px-4 rounded-lg"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Servicios
                  </Link>
                  <Link 
                    to="/productos" 
                    className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer py-2 px-4 rounded-lg"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Productos
                  </Link>
                  <Link 
                    to="/empresas" 
                    className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer py-2 px-4 rounded-lg"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Empresas
                  </Link>
                  <Link 
                    to="/blog" 
                    className="text-red-600 font-semibold cursor-pointer py-2 px-4 rounded-lg"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Blog
                  </Link>
                  <button 
                    onClick={() => {
                      handleWhatsAppContact();
                      setIsMobileMenuOpen(false);
                    }}
                    className="bg-red-600 text-white px-6 py-3 rounded-full hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer mx-4 text-center"
                  >
                    Cotizar Ahora
                  </button>
                </nav>
              </div>
            )}
          </div>
        </header>

        {/* Article Content */}
        <article className="pt-20 md:pt-24 pb-12 md:pb-16">
          <div className="container mx-auto px-4 max-w-4xl">
            <button 
              onClick={() => setSelectedPost(null)}
              className="flex items-center text-red-600 hover:text-red-700 mb-6 md:mb-8 cursor-pointer"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              Volver al Blog
            </button>

            <div className="mb-6 md:mb-8">
              <img 
                src={selectedPost.image}
                alt={selectedPost.title}
                className="w-full h-48 md:h-64 lg:h-96 object-cover object-top rounded-2xl"
              />
            </div>

            <div className="mb-6 md:mb-8">
              <div className="flex items-center mb-4">
                <span className="bg-red-600 text-white px-3 py-1 rounded-full text-sm font-semibold mr-4">
                  {selectedPost.category}
                </span>
                <span className="text-gray-500 text-sm">{selectedPost.readTime} de lectura</span>
              </div>
              
              <h1 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-6">{selectedPost.title}</h1>
              
              <div className="flex items-center mb-4 md:mb-6">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-gray-300 rounded-full flex items-center justify-center mr-3 md:mr-4">
                  <i className="ri-user-line text-gray-600"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900 text-sm md:text-base">{selectedPost.author}</p>
                  <p className="text-sm text-gray-500">{selectedPost.date}</p>
                </div>
              </div>
            </div>

            <div 
              className="prose prose-sm md:prose-lg max-w-none blog-content"
              dangerouslySetInnerHTML={{ __html: selectedPost.content }}
              style={{
                lineHeight: '1.8',
                fontSize: '16px'
              }}
            />

            <style jsx>{`
              .blog-content h2 {
                color: #1f2937;
                font-size: 1.75rem;
                font-weight: 700;
                margin: 2rem 0 1rem 0;
                padding-bottom: 0.5rem;
                border-bottom: 2px solid #dc2626;
              }
              
              .blog-content h3 {
                color: #374151;
                font-size: 1.5rem;
                font-weight: 600;
                margin: 1.5rem 0 0.75rem 0;
              }
              
              .blog-content p {
                color: #4b5563;
                margin: 1rem 0;
                line-height: 1.8;
              }
              
              .blog-content ul, .blog-content ol {
                margin: 1rem 0;
                padding-left: 1.5rem;
              }
              
              .blog-content li {
                color: #4b5563;
                margin: 0.5rem 0;
                line-height: 1.6;
              }
              
              .blog-content strong {
                color: #1f2937;
                font-weight: 600;
              }
              
              @media (max-width: 768px) {
                .blog-content h2 {
                  font-size: 1.5rem;
                }
                
                .blog-content h3 {
                  font-size: 1.25rem;
                }
                
                .blog-content {
                  font-size: 14px;
                }
              }
            `}</style>

            <div className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-gray-200">
              <div className="flex flex-wrap gap-2 mb-4 md:mb-6">
                {selectedPost.tags.map((tag, idx) => (
                  <span key={idx} className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-sm">
                    #{tag}
                  </span>
                ))}
              </div>
              
              <div className="bg-gray-50 rounded-2xl p-6 md:p-8 text-center">
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">¿Necesitas Ayuda Profesional?</h3>
                <p className="text-gray-600 mb-4 md:mb-6 text-sm md:text-base">
                  Nuestro equipo de expertos está listo para ayudarte con cualquier problema electrónico de tu vehículo.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
                  <button 
                    onClick={handlePhoneCall}
                    className="bg-red-600 text-white px-6 py-3 rounded-full hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer text-center"
                  >
                    Llamar Ahora
                  </button>
                  <button 
                    onClick={handleWhatsAppContact}
                    className="bg-green-600 text-white px-6 py-3 rounded-full hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer text-center"
                  >
                    WhatsApp
                  </button>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* Footer */}
        <footer className="bg-gray-900 text-white py-12 md:py-16">
          <div className="container mx-auto px-4">
            <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
              <div>
                <div className="flex items-center space-x-2 md:space-x-3 mb-4 md:mb-6">
                  <img 
                    src="https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/db14669796bfd9c6751821edba8bd22a.png" 
                    alt="Mechatronicx Logo" 
                    className="h-8 md:h-10 w-auto"
                  />
                  <div>
                    <h3 className="text-base md:text-lg font-bold">MECHATRONICX</h3>
                    <p className="text-xs text-gray-400">Soluciones Electrónicas</p>
                  </div>
                </div>
                <p className="text-gray-400 mb-4 text-sm md:text-base">
                  Contenido técnico especializado para profesionales automotrices.
                </p>
              </div>

              <div>
                <h4 className="text-base md:text-lg font-bold mb-4 md:mb-6">Servicios</h4>
                <ul className="space-y-2 md:space-y-3">
                  <li><Link to="/servicios" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm md:text-base">Diagnóstico Automotriz</Link></li>
                  <li><Link to="/servicios" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm md:text-base">Programación de Módulos</Link></li>
                  <li><Link to="/servicios" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm md:text-base">Llaves Inteligentes</Link></li>
                  <li><Link to="/empresas" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm md:text-base">Soluciones Empresariales</Link></li>
                </ul>
              </div>

              <div>
                <h4 className="text-base md:text-lg font-bold mb-4 md:mb-6">Contacto</h4>
                <div className="space-y-2 md:space-y-3">
                  <div className="flex items-center">
                    <i className="ri-map-pin-line text-red-500 mr-2 md:mr-3"></i>
                    <span className="text-gray-400 text-sm md:text-base">Ave Cra 30 #29-09 Sur, Bogotá DC</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-phone-line text-red-500 mr-2 md:mr-3"></i>
                    <span className="text-gray-400 text-sm md:text-base">320 204 7129</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-mail-line text-red-500 mr-2 md:mr-3"></i>
                    <span className="text-gray-400 text-sm md:text-base">administrativo@mechatronicxsas.com</span>
                  </div>
                </div>
              </div>

              <div>
                <h4 className="text-base md:text-lg font-bold mb-4 md:mb-6">Síguenos</h4>
                <div className="flex space-x-4">
                  <a href="https://www.facebook.com/people/Mechatronicx-Especializado/100083428926459/?mibextid=wwXIfr&rdid=8FbzdNPEAxjlrs6r&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F14SQyQT5X5o%2F%3Fmibextid%3DwwXIfr" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                    <i className="ri-facebook-fill text-lg md:text-xl"></i>
                  </a>
                  <a href="https://www.instagram.com/mechatronicxsas/?igsh=MTh0eDQ3MWhnMmh1NA%3D%3D" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                    <i className="ri-instagram-line text-lg md:text-xl"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="border-t border-gray-800 mt-8 md:mt-12 pt-6 md:pt-8 text-center">
              <p className="text-gray-400 text-sm md:text-base">
                © 2024 Mechatronicx SAS. Todos los derechos reservados. | 
                <a href="https://maiketing.agency" target="_blank" rel="noopener noreferrer" className="text-red-500 hover:text-red-400 ml-1 cursor-pointer">
                  Powered by MAIketing.agency
                </a>
              </p>
            </div>
          </div>
        </footer>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-lg fixed w-full top-0 z-50">
        <div className="container mx-auto px-4 py-3 md:py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-2 md:space-x-3 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/db14669796bfd9c6751821edba8bd22a.png" 
                alt="Mechatronicx Logo" 
                className="h-8 md:h-12 w-auto"
              />
              <div>
                <h1 className="text-sm md:text-xl font-bold text-gray-900">MECHATRONICX</h1>
                <p className="text-xs text-gray-600 hidden md:block">Soluciones Electrónicas Automotrices</p>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8">
              <Link to="/" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Inicio</Link>
              <Link to="/servicios" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Servicios</Link>
              <Link to="/productos" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Productos</Link>
              <Link to="/empresas" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Empresas</Link>
              <Link to="/blog" className="text-red-600 font-semibold cursor-pointer">Blog</Link>
              <button 
                onClick={handleWhatsAppContact}
                className="bg-red-600 text-white px-4 xl:px-6 py-2 rounded-full hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer text-sm xl:text-base"
              >
                Cotizar Ahora
              </button>
            </nav>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden text-gray-700 cursor-pointer p-2"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMobileMenuOpen && (
            <div className="lg:hidden mt-4 pb-4 border-t border-gray-200">
              <nav className="flex flex-col space-y-3 pt-4">
                <Link 
                  to="/" 
                  className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer py-2 px-4 rounded-lg"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Inicio
                </Link>
                <Link 
                  to="/servicios" 
                  className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer py-2 px-4 rounded-lg"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Servicios
                </Link>
                <Link 
                  to="/productos" 
                  className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer py-2 px-4 rounded-lg"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Productos
                </Link>
                <Link 
                  to="/empresas" 
                  className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer py-2 px-4 rounded-lg"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Empresas
                </Link>
                <Link 
                  to="/blog" 
                  className="text-red-600 font-semibold cursor-pointer py-2 px-4 rounded-lg"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Blog
                </Link>
                <button 
                  onClick={() => {
                    handleWhatsAppContact();
                    setIsMobileMenuOpen(false);
                  }}
                  className="bg-red-600 text-white px-6 py-3 rounded-full hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer mx-4 text-center"
                >
                  Cotizar Ahora
                </button>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-gray-900 to-red-900 text-white py-12 md:py-20 mt-16 md:mt-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6">Blog Técnico Automotriz</h1>
          <p className="text-lg md:text-xl mb-6 md:mb-8 max-w-3xl mx-auto">
            Mantente actualizado con las últimas tendencias, técnicas y tecnologías 
            en electrónica automotriz. Contenido especializado para profesionales del sector.
          </p>
        </div>
      </section>

      {/* Featured Post */}
      <section className="py-12 md:py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">Artículo Destacado</h2>
          </div>
          
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden max-w-4xl mx-auto">
            <div className="md:flex">
              <div className="md:w-1/2">
                <img 
                  src={featuredPost.image}
                  alt={featuredPost.title}
                  className="w-full h-48 md:h-full object-cover object-top"
                />
              </div>
              <div className="md:w-1/2 p-6 md:p-8">
                <div className="flex items-center mb-4">
                  <span className="bg-red-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                    {featuredPost.category}
                  </span>
                  <span className="text-gray-500 text-sm ml-4">{featuredPost.readTime} de lectura</span>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">{featuredPost.title}</h3>
                <p className="text-gray-600 mb-4 md:mb-6 text-sm md:text-base">{featuredPost.excerpt}</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div className="w-8 h-8 md:w-10 md:h-10 bg-gray-300 rounded-full flex items-center justify-center mr-2 md:mr-3">
                      <i className="ri-user-line text-gray-600 text-xs"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-900 text-sm md:text-base">{featuredPost.author}</p>
                      <p className="text-xs md:text-sm text-gray-500">{featuredPost.date}</p>
                    </div>
                  </div>
                  <button 
                    onClick={() => setSelectedPost(featuredPost)}
                    className="bg-red-600 text-white px-4 md:px-6 py-2 rounded-full hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer text-sm md:text-base"
                  >
                    Leer Más
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Search Section */}
      <section className="py-6 md:py-8 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex justify-center">
            <div className="relative max-w-md w-full">
              <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
              <input
                type="text"
                placeholder="Buscar artículos..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-red-500 text-sm"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-12 md:py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">Todos los Artículos</h2>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {filteredPosts.map((post) => (
              <article 
                key={post.id}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transform hover:-translate-y-2 transition-all duration-300 cursor-pointer"
                onClick={() => setSelectedPost(post)}
              >
                <div className="relative overflow-hidden">
                  <img 
                    src={post.image}
                    alt={post.title}
                    className="w-full h-40 md:h-48 object-cover object-top hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute top-3 md:top-4 left-3 md:left-4">
                    <span className="bg-red-600 text-white px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-semibold">
                      {post.category}
                    </span>
                  </div>
                </div>
                
                <div className="p-4 md:p-6">
                  <div className="flex items-center text-xs md:text-sm text-gray-500 mb-2 md:mb-3">
                    <i className="ri-calendar-line mr-1 md:mr-2"></i>
                    <span>{post.date}</span>
                    <span className="mx-2">•</span>
                    <i className="ri-time-line mr-1 md:mr-2"></i>
                    <span>{post.readTime}</span>
                  </div>
                  
                  <h3 className="text-base md:text-lg font-bold text-gray-900 mb-2 md:mb-3 line-clamp-2">{post.title}</h3>
                  <p className="text-gray-600 mb-3 md:mb-4 text-sm md:text-base">{post.excerpt}</p>
                  
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="w-6 h-6 md:w-8 md:h-8 bg-gray-300 rounded-full flex items-center justify-center mr-2">
                        <i className="ri-user-line text-gray-600 text-xs"></i>
                      </div>
                      <span className="text-xs md:text-sm font-medium text-gray-900">{post.author}</span>
                    </div>
                    <span className="text-red-600 hover:text-red-700 font-medium text-xs md:text-sm cursor-pointer">
                      Leer más <i className="ri-arrow-right-line ml-1"></i>
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>

          {filteredPosts.length === 0 && (
            <div className="text-center py-12 md:py-16">
              <i className="ri-search-line text-4xl md:text-6xl text-gray-300 mb-4"></i>
              <h3 className="text-lg md:text-xl font-semibold text-gray-600 mb-2">No se encontraron artículos</h3>
              <p className="text-gray-500 text-sm md:text-base">Intenta con otros términos de búsqueda</p>
            </div>
          )}
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-12 md:py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="bg-gradient-to-r from-gray-900 to-red-900 rounded-2xl p-8 md:p-12 text-center text-white">
            <h2 className="text-2xl md:text-3xl font-bold mb-3 md:mb-4">Mantente Actualizado</h2>
            <p className="text-lg md:text-xl mb-6 md:mb-8 max-w-2xl mx-auto">
              Recibe los últimos artículos técnicos y noticias de la industria automotriz 
              directamente en tu correo electrónico.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Tu correo electrónico"
                className="flex-1 px-4 py-3 rounded-full text-gray-900 focus:outline-none focus:ring-2 focus:ring-red-500 text-sm md:text-base"
              />
              <button 
                onClick={handleWhatsAppContact}
                className="bg-red-600 text-white px-6 md:px-8 py-3 rounded-full hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                Suscribirse
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 md:py-16">
        <div className="container mx-auto px-4">
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            <div>
              <div className="flex items-center space-x-2 md:space-x-3 mb-4 md:mb-6">
                <img 
                  src="https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/db14669796bfd9c6751821edba8bd22a.png" 
                  alt="Mechatronicx Logo" 
                  className="h-8 md:h-10 w-auto"
                />
                <div>
                  <h3 className="text-base md:text-lg font-bold">MECHATRONICX</h3>
                  <p className="text-xs text-gray-400">Soluciones Electrónicas</p>
                </div>
              </div>
              <p className="text-gray-400 mb-4 text-sm md:text-base">
                Contenido técnico especializado para profesionales automotrices.
              </p>
            </div>

            <div>
              <h4 className="text-base md:text-lg font-bold mb-4 md:mb-6">Servicios</h4>
              <ul className="space-y-2 md:space-y-3">
                <li><Link to="/servicios" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm md:text-base">Diagnóstico Automotriz</Link></li>
                <li><Link to="/servicios" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm md:text-base">Programación de Módulos</Link></li>
                <li><Link to="/servicios" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm md:text-base">Llaves Inteligentes</Link></li>
                <li><Link to="/empresas" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm md:text-base">Soluciones Empresariales</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-base md:text-lg font-bold mb-4 md:mb-6">Contacto</h4>
              <div className="space-y-2 md:space-y-3">
                <div className="flex items-center">
                  <i className="ri-map-pin-line text-red-500 mr-2 md:mr-3"></i>
                  <span className="text-gray-400 text-sm md:text-base">Ave Cra 30 #29-09 Sur, Bogotá DC</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-phone-line text-red-500 mr-2 md:mr-3"></i>
                  <span className="text-gray-400 text-sm md:text-base">320 204 7129</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-mail-line text-red-500 mr-2 md:mr-3"></i>
                  <span className="text-gray-400 text-sm md:text-base">administrativo@mechatronicxsas.com</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-base md:text-lg font-bold mb-4 md:mb-6">Síguenos</h4>
              <div className="flex space-x-4">
                <a href="https://www.facebook.com/people/Mechatronicx-Especializado/100083428926459/?mibextid=wwXIfr&rdid=8FbzdNPEAxjlrs6r&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F14SQyQT5X5o%2F%3Fmibextid%3DwwXIfr" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg md:text-xl"></i>
                </a>
                <a href="https://www.instagram.com/mechatronicxsas/?igsh=MTh0eDQ3MWhnMmh1NA%3D%3D" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-lg md:text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 md:mt-12 pt-6 md:pt-8 text-center">
            <p className="text-gray-400 text-sm md:text-base">
              © 2024 Mechatronicx SAS. Todos los derechos reservados. | 
              <a href="https://maiketing.agency" target="_blank" rel="noopener noreferrer" className="text-red-500 hover:text-red-400 ml-1 cursor-pointer">
                Powered by MAIketing.agency
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BlogPage;
